import { FC, InputHTMLAttributes } from "react";
import {
  Box,
  BoxProps,
  InputLabel,
  makeStyles,
  TextField,
  TextFieldProps,
} from "@material-ui/core";

import theme from "theme";

interface OwnProps {
  label: string;
  name: string;
  containerProps?: BoxProps;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

const useLabelStyles = makeStyles({
  root: {
    color: theme.custom.palette.black.main,
  },
});

export type OutlinedTextFieldProps = OwnProps &
  Omit<TextFieldProps, "name" | "label">;

const OutlinedTextField: FC<OutlinedTextFieldProps> = ({
  children,
  label,
  name,
  containerProps = {},
  inputProps,
  ...restProps
}) => {
  const labelClasses = useLabelStyles();

  return (
    <Box {...containerProps}>
      <Box pb={1}>
        <InputLabel className={labelClasses.root} htmlFor={name}>
          {label}
        </InputLabel>
      </Box>
      <TextField
        id={name}
        name={name}
        variant="outlined"
        fullWidth
        select={!!children}
        size="small"
        inputProps={inputProps}
        {...restProps}
      >
        {children ?? null}
      </TextField>
    </Box>
  );
};

export default OutlinedTextField;
